import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { Config } from '../../config';

const initKycMFEApiService = async () => {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const initKYCMFEApiServiceModule = await import('kyc/initKYCMFEApiService');
    const initKYCMFEApiService = initKYCMFEApiServiceModule.default;
    const { initSmApiService } = initKYCMFEApiServiceModule;
    const basePath = Config.CURRENT_ORIGINS.KYC.replace('/api', '');
    initKYCMFEApiService(RedisApiAxiosInstance, basePath);
    initSmApiService(RedisApiAxiosInstance, !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.SM);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initKycMFEApiService', e);
  }
};

export default initKycMFEApiService;
